import { Button, Div, Text, PasswordInput, Ref, Span } from "@tblabs/truffle";
import { Page } from "./Page";
import { ConfigProvider } from "../Services/ConfigProvider";
import { ServerSelector } from "../Components/ServerSelector";
import { AuthService } from "../Services/AuthService";
import { PasswordSanitizer } from "../Utils/PasswordSanitizer";


export class LoginPage extends Page
{
    private password = new Ref<string>("").Storable("admin-password-input");
    private loginButton = new Button("LOGIN").Class("btn half");
    private loginStatus = new Ref<string>("");
    private statusBox = new Text(this.loginStatus).Class("info").Hide();

    constructor(
        private _auth: AuthService,
        private _config: ConfigProvider)
    {
        super("TX Admin 4.0.0", "LoginPage");
    }

    protected async OnAppend(): Promise<void>
    {
        const passwordInput = new PasswordInput(this.password).TogglePasswordView()
            .Placeholder("Case and spacing are insignificant")
            .OnEnterKeyPressed(async () => await this.TryLogin())
            .OnKeyDown(() => this.statusBox.Hide());

        this.loginButton
            .OnClick(async () => await this.TryLogin());

        this.body
            .MarginAuto()
            .PaddingTop(32)
            .TextAlignCenter()
            .Append(
                new Div("row").TextAlignLeft().MarginBottom(4)
                    .Append(new Span("PASSWORD").Class("title")),
                new Div("row")
                    .Append(passwordInput),
                new Div("row").TextAlignRight()
                    .Append(
                        this.loginButton.Class("uk-button-primary")
                    ),
                new Div("row")
                    .Append(this.statusBox),
                new Div("row").FullWidth().Left(0).PositionAbsolute().Bottom(68).TextAlignCenter()
                    .Append(
                        new ServerSelector(this._config),
                    ),
            );
        this.footer.Append(
            new Span(`TX-Admin v.4.0.0 @ ${process.env.NODE_ENV}`),
        )
    }

    private async TryLogin(): Promise<void>
    {
        const sanitizedPassword = PasswordSanitizer.Sanitize(this.password.value);

        if (sanitizedPassword == "")
        {
            this.statusBox.Show();
            this.loginStatus.value = "No password provided";
            return;
        }

        this.loginButton.Label("Trying to login...");

        const timer = setTimeout(() =>
        {
            this.statusBox.Show();
            this.loginStatus.value = "Authorization timeout. Try again later";
            this.loginButton.Label("Try again");
        }, 15000);

        const result = await this._auth.TryLogin(sanitizedPassword);

        clearTimeout(timer);

        if (result.Authorized === true)
        {
            window.location.hash = "panel";
        }
        else
        {
            this.statusBox.Show();
            this.loginStatus.value = result.Message || "Authorization problem";
            this.loginButton.Label("Try again");
        }
    }
}
